import { createActionsHook } from 'src/lib/sweetState';

import { UiStore } from './UiStore';

export const useUiActions = createActionsHook(UiStore);
